import { GridCellProps } from '@progress/kendo-react-grid';
import { TextBoxChangeEvent } from '@progress/kendo-react-inputs';
import { useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import NumberInput from 'src/components/NumberInput';
import { CanManageBudgets, CanOverrideBudgets } from 'src/constants/permissionsList';
import usePeriodView from 'src/hooks/usePeriodView';
import usePermission from 'src/hooks/usePermissions';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { getBgColor } from 'src/utils/icons';

const BudgetAmountDisplayCell = (props: GridCellProps) => {
  const { isEditMode, isCheckbookEditable } = useViewCheckbook();
  const { isCurrentPeriodPassed } = usePeriodView();
  const { dataItem, dataIndex, field = '', onChange } = props;
  const { isDeleted, warnings } = dataItem;
  const { displayValue, value } = useGridCellDisplayValue(props);
  const canOverrideInitialBudget = usePermission({ permissions: CanOverrideBudgets });
  const manageBudgets = usePermission({ permissions: CanManageBudgets });
  const editable =
    isEditMode && !isDeleted && !isCurrentPeriodPassed && manageBudgets && isCheckbookEditable
      ? canOverrideInitialBudget
        ? true
        : dataItem._initialBudget === null
      : false;

  const handleBudgetChange = useCallback(
    (e: TextBoxChangeEvent) => {
      onChange?.({
        dataIndex: dataIndex,
        dataItem: dataItem,
        syntheticEvent: e.syntheticEvent,
        field: field,
        value: e.value === '' ? null : e.value,
      });
    },
    [dataIndex, dataItem, field, onChange]
  );

  const isNull = value === null;
  const formattedValue = !isNull ? displayValue : '';

  return (
    <GridCellBase
      {...props}
      title={formattedValue}
      rowSelectionEnabled
      className={` ${getBgColor([], warnings?.initialBudget as string[])} !text-end ${
        !isEditMode && Number(value) < 0 ? 'budget-cell-color' : ''
      }`}
    >
      {editable ? (
        <NumberInput
          value={!isNull ? String(value) : ''}
          onChange={handleBudgetChange}
          prefix="$"
        />
      ) : (
        <span>{formattedValue}</span>
      )}
    </GridCellBase>
  );
};

export default BudgetAmountDisplayCell;
